import React from 'react';
import { Reveal } from '../Reveal';
type FigureProps = {
  children: React.ReactNode;
  caption?: string;
  className?: string;
};
export function Figure({
  children,
  caption,
  className
}: FigureProps) {
  return <Reveal className={className} data-id="element-118" data-mp="23kof8rr6u2jj">
      <figure data-id="element-119" data-mp="23lq0tq5ty7fi">
        {children}
        {caption && <figcaption className="mt-3 text-xs leading-relaxed text-fg-faint" data-id="element-120" data-mp="28izn4wxxa2z4">{caption}</figcaption>}
      </figure>
    </Reveal>;
}